module.exports = __webpack_public_path__ + "img/51_59.6221c525.png";